import { render, staticRenderFns } from "./ListActionbar.vue?vue&type=template&id=b67d47b6&"
import script from "./ListActionbar.vue?vue&type=script&lang=js&"
export * from "./ListActionbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListActionbar.vue"
export default component.exports